import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  public isAesEnabled: boolean = false;

  constructor(private http: HttpClient) { }

  loadConfig(): Promise<any> {
    const url = '/Account/Aes256Enabled';

    // 1. Add { responseType: 'text' } options
    // 2. Remove <boolean> generic type because we are now getting a string
    return this.http.get(url, { responseType: 'text' })
      .pipe(
        tap((responseString: string) => {
          // 3. Manually convert "True"/"False" string to boolean
          // This handles "True", "true", "TRUE", etc.
          const result = responseString.toLowerCase() === 'true';

          console.log('App Config Loaded. AES Enabled:', result);
          this.isAesEnabled = result;
        })
      )
      .toPromise()
      .catch((err) => {
        console.error('Failed to load AES config', err);
        this.isAesEnabled = false;
        return Promise.resolve();
      });
  }


}
